var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sections-navbar hidden-print" },
    [
      _vm.sections
        ? _c(
            "affix",
            {
              attrs: {
                "relative-element-selector": _vm.relativeElementSelector,
                offset: { top: _vm.affixOffset, bottom: -2000 },
              },
            },
            [
              [
                _c("div", { staticClass: "visible-xs visible-sm container" }, [
                  _c(
                    "div",
                    { staticClass: "travel-detail-section-dropdown row" },
                    [
                      _c(
                        "div",
                        { staticClass: "dropdown" },
                        [
                          _c(
                            "scrollactive",
                            {
                              staticClass: "sections-dropdown-nav nav",
                              attrs: {
                                id: _vm.context + "-sections-dorpdown-nav",
                                offset: _vm.affixOffset,
                                highlightFirstItem: true,
                                "modify-url": false,
                                alwaysTrack: true,
                              },
                              on: { itemchange: _vm.selectDropdownItem },
                            },
                            [
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-button-wrapper",
                                    on: { click: _vm.toggleDropdown },
                                  },
                                  _vm._l(_vm.sections, function (s, key) {
                                    return _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn dropdown-btn scrollactive-item",
                                        staticStyle: {
                                          display: "none",
                                          "pointer-events": "none",
                                        },
                                        attrs: {
                                          href: "#section-" + key,
                                          type: "button",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(s) + "\n                    "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "icon inline very-small icon-arrow-bottom",
                                        }),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.showJumpbarDropdown
                                  ? _c(
                                      "ul",
                                      {
                                        staticClass: "dropdown-menu",
                                        attrs: {
                                          id: "travel-detail-jumpbar-menu",
                                          "aria-labelledby": "dLabel",
                                        },
                                      },
                                      _vm._l(_vm.sections, function (s, key) {
                                        return _c("li", {}, [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "sections-navbar-dropdown-item scrollactive-item",
                                              attrs: {
                                                href: "#section-" + key,
                                              },
                                              on: {
                                                "&click": function ($event) {
                                                  return _vm.selectDropdownItem(
                                                    key
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(s))]
                                          ),
                                        ])
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                              ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-primary btn-inline pull-right highlight-button",
                              attrs: {
                                href: _vm.buchenLink,
                                disabled: !_vm.buchenLink ? true : false,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.buchenText) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "visible-md visible-lg" }, [
                  _c("div", { staticClass: "travel-detail-section" }, [
                    _c("div", { staticClass: "container" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12" },
                          [
                            _c(
                              "scrollactive",
                              {
                                staticClass: "sections-nav nav",
                                attrs: {
                                  id: _vm.context + "-sections-nav",
                                  offset: _vm.affixOffset,
                                  highlightFirstItem: true,
                                  alwaysTrack: true,
                                  "modify-url": false,
                                },
                              },
                              [
                                _c(
                                  "ul",
                                  { staticClass: "list-inline" },
                                  [
                                    _vm._l(_vm.sections, function (s, key) {
                                      return _c("li", {}, [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-transparent btn-inline sections-navbar-item scrollactive-item",
                                            attrs: { href: "#section-" + key },
                                          },
                                          [_c("span", [_vm._v(_vm._s(s))])]
                                        ),
                                      ])
                                    }),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "btn btn-primary highlight-button",
                                          attrs: {
                                            href: _vm.buchenLink,
                                            disabled: !_vm.buchenLink
                                              ? true
                                              : false,
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.buchenText)),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ],
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }